import React from 'react'
import { Form, Button, Input, Icon } from 'antd';


class ContributorsFilter extends React.Component {
  render() {

    return (
      <div className="panel">
        <Form layout="inline" onSubmit={this.props.sumbitFilter}>
          <Form.Item label="Filter">
            <Input prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Filter" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" shape="circle" icon="search" htmlType="submit"></Button>
          </Form.Item>
          <Form.Item style={{ float: 'right' }} >
            <Button type="" icon="plus" onClick={this.props.addNew} >Add Member</Button>
          </Form.Item>

        </Form>
      </div>)
  }

}

export default ContributorsFilter
